'use client';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { ProgressBarState } from '@/atoms/progressBar/progressBarState';
import { type Progress } from '@/services/funnelService/types';

const ProgressBarAtomSetter = ({
  children,
  currentSlug,
  progress,
}: {
  children?: React.ReactNode;
  currentSlug?: string;
  progress?: Progress;
}) => {
  const setProgress = useSetAtom(ProgressBarState.progressBarAtom);

  useEffect(() => {
    if (currentSlug && progress) {
      setProgress({
        currentSlug,
        progress,
      });
    }
  }, [currentSlug, progress, setProgress]);

  return children;
};

export default ProgressBarAtomSetter;
